import React, { ReactChild } from 'react';
import ReactModal from 'react-modal';

const Modal = ({
  children,
  isOpen,
  onAfterClose = () => {},
  okText,
  cancelText,
  onRequestClose,
}: {
  children: ReactChild;
  isOpen: boolean;
  onAfterClose?: () => void;
  onRequestClose?: () => void;
  okText?: string;
  cancelText?: string;
}) => {
  return (
    <ReactModal
      onAfterClose={onAfterClose}
      onRequestClose={onRequestClose}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
      isOpen={isOpen}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          background: 'transparent',
          border: 'none',
          borderRadius: 2,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.57)',
          zIndex: 1000,
        },
      }}>
      {children}
    </ReactModal>
  );
};

export default Modal;
